module.exports = __webpack_public_path__ + "img/rupesh.ed9d635f.png";